import {createMuiTheme} from '@material-ui/core'


export default createMuiTheme({
    typography: {
        useNextVariants: true,
        fontFamily: '"Montserrat"',
    }
})
